module.exports = __webpack_public_path__ + "img/programmer-and-coding-concept.20ebca56.jpg";